import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';
import ua from '@/assets/locales/ua.json';
import ru from '@/assets/locales/ru.json';
import en from '@/assets/locales/en.json';

Vue.use(VueI18n);

const messages = { ua, ru, en };

function customRule(choice, choicesLength) {
  if (choice === 0) { return 0 };
  const teen = choice > 10 && choice < 20;
  const endsWithOne = choice % 10 === 1;
  if (choicesLength < 4) { return (!teen && endsWithOne) ? 1 : 2 };
  if (!teen && endsWithOne) { return 1; }
  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) { return 2 };
  return (choicesLength < 4) ? 2 : 3;
};

const i18n = new VueI18n({
  locale: store.getters['settings/lang'],
  formatFallbackMessages: true,
  silentTranslationWarn: true,
  messages,
  pluralizationRules: {
    ru: customRule,
    ua: customRule,
  },
});

export default i18n;
